export default {
  data () {
    return {
      fromRoute: undefined
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.fromRoute = from
    })
  },
  methods: {
    goBack (fallBackUrl) {
      if (this.fromRoute.path !== '/') {
        this.$router.push(this.fromRoute)
      } else {
        this.$router.push(fallBackUrl || '/')
      }
    }
  }
}
